export const API_SIGNUP = 'apiSignup'
export const API_LOGIN = 'loginApi'
export const API_LOGOUT = 'logoutApi'
export const SIGNUP_CLIENT = 'signUpClient'
export const REQUEST_RECOVERY_PASSWORD = 'requestRecoveryPassword'
export const CHANGES_PASSWORD = 'changesPassword'
